import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import {
  APIs,
  SEARCH_SUGGESTION_KEY
} from "@website/ticket-ui/common/constants";
import { AirportsItemType } from "@website/ticket-ui/common/types";

const SearchSuggestionsUrl = `${APIs.baseUrlStore}/assets/json/dom-flight-search-suggestions.json`;
export const useDomFlightSearchSuggestionsService = () => {
  const response = useFetcher({
    queryKey: [SEARCH_SUGGESTION_KEY],
    queryFn: () =>
      fetcher({
        url: SearchSuggestionsUrl,
        headers: {
          Authorization: ""
        }
      }).then(({ data }: { data: Array<AirportsItemType> }) => data)
  });
  return response;
};
